import { IDENTIFIER } from '../actions';
import { ListReducerBuilder } from '../../../../utils/reducers';

export default new ListReducerBuilder(IDENTIFIER).build();
